import React, {useState} from "react";

export type ZoneContextI = {
    setSelectedZone: (id: string | undefined) => void
    getSelectedZone: () => string | undefined,

}


export const ZoneContext = React.createContext<ZoneContextI>(
    {
        getSelectedZone: () => undefined,
        setSelectedZone: () => null
    }
);

export const ZoneContextWrapper = ({children}: { children: any }) => {
    const [selectedZone, setSelectedZone] = useState<string | undefined>(undefined);

    return <ZoneContext.Provider value={
        {
            setSelectedZone: setSelectedZone,
            getSelectedZone: () => selectedZone
        }
    }>
        {children}
    </ZoneContext.Provider>
}